'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findAssignedResponder = undefined;

var _immutable = require('immutable');

var _responderGetters = require('../../responders/operators/responderGetters');

var _getAssignedAgentId = require('../../operators/conversation/getAssignedAgentId');

var _getAssignedAgentId2 = _interopRequireDefault(_getAssignedAgentId);

var _threadGetters = require('./threadGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findAssignedResponder = exports.findAssignedResponder = function findAssignedResponder(_ref) {
  var thread = _ref.thread,
      _ref$responders = _ref.responders,
      responders = _ref$responders === undefined ? (0, _immutable.List)() : _ref$responders,
      botResponder = _ref.botResponder;

  if (!thread && !botResponder) {
    return null;
  }

  var initialAssignedResponder = (0, _threadGetters.getResponder)(thread);

  var assignedAgent = (responders || (0, _immutable.List)()).find(function (responder) {
    return '' + (0, _responderGetters.getUserId)(responder) === '' + (0, _getAssignedAgentId2.default)(thread);
  });

  return assignedAgent || botResponder || initialAssignedResponder || null;
};